module.exports = __webpack_public_path__ + "img/zimowy_poranek.033b6807.jpg";